var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNoLeads = function SvgNoLeads(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m8 9 7.517 10.416v7.232h5.807v-7.232L28.84 9H8zm8.517 10.093L9.955 10h16.931l-6.562 9.093v6.555h-3.807v-6.555z",
    fill: "#B7B7B7",
    fillRule: "evenodd"
  })));
};
export { SvgNoLeads as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzYiIGhlaWdodD0iMzYiIHZpZXdCb3g9IjAgMCAzNiAzNiIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICAgIDxwYXRoIGQ9Im04IDkgNy41MTcgMTAuNDE2djcuMjMyaDUuODA3di03LjIzMkwyOC44NCA5SDh6bTguNTE3IDEwLjA5M0w5Ljk1NSAxMGgxNi45MzFsLTYuNTYyIDkuMDkzdjYuNTU1aC0zLjgwN3YtNi41NTV6IiBmaWxsPSIjQjdCN0I3IiBmaWxsLXJ1bGU9ImV2ZW5vZGQiLz4KPC9zdmc+Cg==";